import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority"

import { cn } from "../../lib/utils"

const buttonVariants = cva(
	"inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full text-sm font-medium transition-all disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:ring-primary/50 focus-visible:ring-[3px]",
	{
		variants: {
			variant: {
				default:
					"bg-linear-to-tr from-orange-400 to-orange-500 text-white hover:shadow-lg hover:shadow-orange-500/30 hover:bg-orange-600",
				destructive: "bg-red-500 text-white hover:bg-red-500/90",
				outline:
					"border border-primary text-primary bg-background hover:bg-primary/10",
				secondary: "bg-secondary text-white hover:bg-secondary/90",
				ghost: "hover:bg-primary/10 hover:text-primary",
				link: "text-primary underline-offset-4 hover:underline",
			},
			size: {
				default: "h-9 px-4 py-2 has-[>svg]:px-3",
				sm: "h-8 rounded-full gap-1.5 px-3 has-[>svg]:px-2.5",
				lg: "h-10 rounded-full px-6 has-[>svg]:px-4",
				icon: "size-16",
				"icon-sm": "size-12",
				"icon-lg": "size-[4.5rem]",
			},
		},
		defaultVariants: {
			variant: "default",
			size: "default",
		},
	},
)

function Button({ className, variant, size, asChild = false, ...props }) {
	const Comp = asChild ? Slot : "button"

	return (
		<Comp
			data-slot="button"
			className={cn(buttonVariants({ variant, size, className }))}
			{...props}
		/>
	)
}

export { Button, buttonVariants }
